import React from 'react';
import { useHawkSearch } from 'components/StoreProvider';
import { ScrollToResults } from 'features/search/FacetsAndResults';
import { useTranslation } from 'react-i18next';

function ItemsPerPage(props: ScrollToResults) {
	const { t } = useTranslation();
	const { scrollToResults } = props;

	const {
		store: { searchResults, pendingSearch },
		actor,
	} = useHawkSearch();

	function onChangeAndBlur(event: React.ChangeEvent<HTMLSelectElement>) {
		actor.setSearch({
			MaxPerPage: Number(event.currentTarget.value),
			PageNo: 1, // if we change our max items per page, reset to page 1
		});

		if (event.type !== 'blur') {
			scrollToResults(t('items per page'));
		}
	}

	return (
		<div className="hawk-items-per-page">
			<span>View</span>
			<select
				value={pendingSearch.MaxPerPage}
				onChange={onChangeAndBlur}
				onBlur={onChangeAndBlur}
				//# region HCL
				id="hawk-items-per-page-selector"
				// #endregion
			>
				{searchResults ? (
					searchResults.Pagination.Items.map((paginationItem) => (
						<option key={paginationItem.PageSize} value={paginationItem.PageSize}>
							{paginationItem.Label}
						</option>
					))
				) : (
					<option>{t('12 Items Per Page')}</option>
				)}
			</select>
		</div>
	);
}

export default ItemsPerPage;
